
import { Calendar, Image } from "lucide-react";
import { Button } from "@/components/ui/button";

const Hero = () => {
  const scrollToBooking = () => {
    const bookingSection = document.getElementById("booking");
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToGallery = () => {
    const gallerySection = document.getElementById("gallery");
    if (gallerySection) {
      gallerySection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="relative h-[80vh] w-full">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ 
          backgroundImage: 'url("/lovable-uploads/7ebf536f-4efb-4bcd-873a-e7b04af7ebdc.png")',
        }}
      >
        <div className="absolute inset-0 bg-black/40" />
      </div>
      <div className="relative h-full flex items-center justify-center text-center">
        <div className="max-w-3xl px-4 space-y-6">
          <h1 className="text-4xl md:text-6xl font-bold text-white">
            Welcome to BeachBreak
          </h1>
          <p className="text-2xl md:text-3xl font-semibold text-white/90">
            Great Vibes. Great Location. Great Getaway.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Button size="lg" className="bg-primary hover:bg-primary/90" onClick={scrollToBooking}>
              <Calendar className="mr-2 h-5 w-5" />
              Check Availability
            </Button>
            <Button size="lg" variant="secondary" onClick={scrollToGallery}>
              <Image className="mr-2 h-5 w-5" />
              View Property
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
